module.exports = __webpack_public_path__ + "media/images/logo-freshbooks-a6849b5538bfa8e7f2ed224cc8e3dc31.png";